export default __webpack_public_path__ + "static/media/156.8fade06e.jpg";